const INVITE_CODE_KEY = 'outof195.inviteCode'
const INVITE_CODE_ERROR_KEY = 'outof195.inviteCodeError'

export const inviteCode = {
    get: () => sessionStorage.getItem(INVITE_CODE_KEY) || '',
    getError: () => sessionStorage.getItem(INVITE_CODE_ERROR_KEY) || '',
    set: code => {
        sessionStorage.setItem(INVITE_CODE_KEY, code.trim().toUpperCase())
        sessionStorage.removeItem(INVITE_CODE_ERROR_KEY)
    },
    reject: errorCode => sessionStorage.setItem(INVITE_CODE_ERROR_KEY, errorCode),
    clear: () => {
        sessionStorage.removeItem(INVITE_CODE_KEY)
        sessionStorage.removeItem(INVITE_CODE_ERROR_KEY)
    },
}
